import React from 'react';
import { faFacebookF, faYoutube, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function SocialMediaLinks() {
  return (
    <div className="follow">
        <a href="https://www.youtube.com/channel/UC-ZfjkM9bKftOO8RH3vQDBw" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faYoutube} />
        </a>
        <a href="https://www.facebook.com/Planning2050" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faFacebookF} />
        </a>
        <a href="https://twitter.com/plgcommitment" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faTwitter} />
        </a>
        <a href="https://www.instagram.com/plgcommitment/?hl=en" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a href="https://www.linkedin.com/posts/planningcommitment_about-activity-7126307737956737025-EAxG/" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faLinkedin} />
        </a>

    </div>
  );
}

export default SocialMediaLinks;